import { faBuilding as fasBuilding } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import type { LeadFormProps, LeadFormStepFields } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { FormCurrency, FormInput } from "@/shared/ui";

const MIN_COMPANY_NAME_LENGTH = 2;
const MAX_COMPANY_NAME_LENGTH = 40;

interface Props extends LeadFormProps {
	withLoanAmount?: boolean;
}

export class LeadForm extends BasicLeadForm<LeadFormStepFields, Props> {
	protected renderFields(): ReactNode {
		const { submitState, withLoanAmount } = this.props;

		return (
			<>
				{super.renderFields()}
				<FormInput
					placeholder="Cégnév"
					name="companyName"
					prepend={<FontAwesomeIcon icon={fasBuilding} />}
					validate={this.validCompanyName}
					disabled={submitState !== undefined}
					required
				/>
				{withLoanAmount && (
					<FormCurrency
						placeholder="Hitelösszeg"
						name="loanAmount"
						validate={this.validLoanAmount}
						required
					/>
				)}
			</>
		);
	}

	private validCompanyName(_companyName: string): string {
		if (!_companyName) {
			return "A cégnév megadása kötelező!";
		}

		const companyName = _companyName?.trim();

		if (companyName.length < MIN_COMPANY_NAME_LENGTH) {
			return `A cégnév legalább ${MIN_COMPANY_NAME_LENGTH} karakterből kell, hogy álljon!`;
		}

		if (companyName.length > MAX_COMPANY_NAME_LENGTH) {
			return `A cégnév legfeljebb ${MAX_COMPANY_NAME_LENGTH} karakterből állhat!`;
		}
	}

	private validLoanAmount(loanAmount: number): string {
		if (!loanAmount || loanAmount <= 0) {
			return "Kérjük, add meg az igényelt hitelösszeget!";
		}
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
